module.exports = __webpack_public_path__ + "img/logo-maif-2_2x.ba1cd977.webp";